<div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between nav-height">
        <a
            class="weight-medium"
            tabindex="0"
            (click)="viewEndCustomer()"
            (keypress)="viewEndCustomer()"
        >
            <i class="fa-duotone fa-light fa-arrow-left pe-1"></i>
            Back
        </a>
    </div>
</div>

<telxl-shared-customer-directory-panel
    [customButtonTemplate]="customerDirectoryButtonTemplate"
    [businessUnitId]="businessUnitId()"
    [customerId]="customerId()"
    (clicked)="viewCustomer($event)"
    height="calc(100vh - 260px)"
/>

<ng-template #customerDirectoryButtonTemplate let-select="select">
    <telxl-button class="w-100" colour="primary" (buttonClick)="select()">
        View
    </telxl-button>
</ng-template>
